import Crud from '../views/Assunto/Crud'
import Entity from '../views/Assunto/Add'

let routes = {
    path: '/assuntos',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/assuntos/add',
            name: 'NewAssunto',
            component: Entity,
            meta: {
                pageTitle: 'Assuntos',
                breadcrumb: [
                    {
                        text: 'Assuntos',
                        active: false,
                        to: '/assuntos',
                    },
                    {
                        text: 'Criar',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/assuntos/edit/:id?',
            name: 'EditAssunto',
            component: Entity,
            meta: {
                pageTitle: 'Assuntos',
                breadcrumb: [
                    {
                        text: 'Assuntos',
                        active: false,
                        to: '/assuntos',
                    },
                    {
                        text: 'Editar',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/assuntos/view/:id',
            redirect: to => ({ path: '/documentos', query: { assunto_id: to.params.id } }),
        },
        {
            path: '/assuntos',
            name: 'list-assuntos',
            component: Crud,
            meta: {
                pageTitle: 'Gestão de Documentos',
                breadcrumb: [
                    {
                        text: 'Assuntos',
                        active: true,
                    },
                ],
            },
        },
    ]
}

export default routes
